import {
    Component,
    ElementRef,
    EventEmitter,
    Input
} from '@angular/core';
import { Item } from '../../../../baseObjects/item';

@Component({
    selector: 'toolbar-item',
    templateUrl: 'toolbar-item.nested.html'
})
export class ToolbarItemComponent extends Item {
    // properties
    @Input() location: string = 'before'; // before, center, after

    constructor(public elementRef: ElementRef) {
        super();
        this.onClick = new EventEmitter<any>();
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/toolbar/nested/item/toolbar-item.nested.ts